module.exports = __webpack_public_path__ + "static/media/Logo_01.cc6f5038.svg";